import { Box } from "@mui/system";
import React from "react";

const AppParagraph = ({ children }: { children: React.ReactNode }) => <Box sx={{ margin: "0.5em 0 0 0" }}>{children}</Box>
export default AppParagraph;